<template>
  <div class="nav-wrapper">
    <v-app-bar app color="#fff" light elevation="1">
      <v-toolbar-title class="hidden-xs-only menu-title" @click="$router.push('/')">
        <v-chip outlined color="primary">
          {{ translate($store.getters.content.page_title) }}
        </v-chip>
      </v-toolbar-title>
      <v-spacer class="hidden-xs-only"></v-spacer>
      <v-btn @click="$router.push('/')" class="me-2 ms-0 home-button-mobile" elevation="0"><v-icon>mdi-home</v-icon></v-btn>
      <select-language />
      <v-spacer class="d-flex d-sm-none"></v-spacer>

      <v-menu right bottom offset-y v-if="userObject">
        <template v-slot:activator="{ on }">
          <div class="user-dropdown-menu">
            <v-btn v-on="on" class="me-0" icon elevation="0">
              <v-icon large>mdi-account-circle</v-icon>
            </v-btn>
          </div>
        </template>

        <v-list class="px-4">
          <v-list-item>
            <v-list-item-content>
              <v-icon large slot="start">mdi-account-circle</v-icon>
              <v-list-item-title class="subtitle-1 text-center">
                {{ userObject.given_name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class=""></v-divider>
          <v-list-item @click="logout()">
            <v-list-item-title>
              <v-icon left>mdi-logout-variant</v-icon>
              Logout
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
import SharedFunctionsMixin from '@/mixins/SharedFunctions.vue';
import SelectLanguage from '@/components/generic/select-language.vue';

export default {
  mixins: [SharedFunctionsMixin],
  components: {
    SelectLanguage,
  },
  data() {
    return {
      drawer: true,
    };
  },
  computed: {
    userObject: {
      //return this.$store.getters.userObject;
      get() {
        return this.$store.getters.userObject;
      },
      set(value) {
        this.$store.commit('SET_USER_OBJECT', value);
      },
    },
    keycloak() {
      return this.$store.state.keycloak;
    },
    auth() {
      return this.$store.state.auth;
    },
  },
  mounted() {
    this.drawer = this.$vuetify.breakpoint.mdAndDown ? false : true;
  },
  methods: {
    async logout() {
      const logoutUrl = this.keycloak.createLogoutUrl({ redirectUri: window.location.origin });
      // const logoutUrl = this.auth.logoutUrl;
      this.userObject = null;
      this.$store.commit('SET_AUTH_TOKEN', null);
      this.$store.commit('SET_AUTH_REFRESH_TOKEN', null);
      this.$store.commit('SET_AUTHENTICATED', false);
      this.$store.commit('RESET_INTAKE_FORM_DATA', { state: this.$store.state });
      this.$store.commit('SET_CURRENT_STEP_INTAKE_FORM', 1);
      localStorage.removeItem('dvg-hoh-forms-dashboard-kc-token');
      localStorage.removeItem('dvg-hoh-forms-dashboard-kc-refresh-token');
      window.location.href = logoutUrl;
    },
  },
};
</script>

<style lang="scss">
.nav-wrapper {
  .v-toolbar__title {
    overflow: visible;
  }

  .menu-title {
    font-size: 16px !important;
    text-transform: uppercase;
    font-weight: 600;
    color: grey;
    span {
      &:hover {
        cursor: pointer;
      }
    }
  }

  .v-list-item--active {
    color: #36a0dd !important;
    &:before {
      background: none;
    }
  }

  .account-icon {
    color: gray;
  }

  .user-dropdown-menu {
    border-left: 1px solid #cacaca;
    display: flex;
    height: 45px;
    margin-left: 10px;
    padding-left: 8px;
  }

  .home-button-mobile {
    display: none;
    padding: 0px !important;
    min-width: 40px !important;
    border-radius: 60px;
    min-height: 40px !important;
    background: lighten(#36a0dd, 40%) !important;
    color: #36a0dd !important;
  }

  /* Extra Small Devices, Phones */
  @media only screen and (max-width: 600px) {
    .home-button-mobile {
      display: block;
    }
  }
}
</style>
